var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpense1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H13.5V12H12V9Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.25V3.75C15 2.92275 14.3273 2.25 13.5 2.25H3.75C2.5095 2.25 1.5 3.2595 1.5 4.5V13.5C1.5 15.1508 2.8455 15.75 3.75 15.75H15C15.8273 15.75 16.5 15.0773 16.5 14.25V6.75C16.5 5.92275 15.8273 5.25 15 5.25ZM3.75 3.75H13.5V5.25H3.75C3.55689 5.24136 3.37455 5.15857 3.24096 5.01886C3.10736 4.87916 3.0328 4.6933 3.0328 4.5C3.0328 4.3067 3.10736 4.12084 3.24096 3.98114C3.37455 3.84143 3.55689 3.75864 3.75 3.75ZM15 14.25H3.759C3.4125 14.241 3 14.1038 3 13.5V6.61125C3.2355 6.696 3.48525 6.75 3.75 6.75H15V14.25Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense1);
export default __webpack_public_path__ + "static/media/expense1.664e33df76fdbc0482591fa426fa995d.svg";
export { ForwardRef as ReactComponent };